<template>
  <div class="user-wrapper">
    <!-- <span class="action">
      <a-icon type="question-circle-o"></a-icon>
    </span> -->
    <!-- 跳转链接 -->
    <ul class="nav-menu">
      <li><span @click="navTo(jumpConfiguration.console)">{{ $t('globalHeader.store') }}</span></li>
      <li><span @click="jumpSNSLink">{{ $t('globalHeader.community') }}</span></li>
      <li v-if="false"><span @click="navTo(jumpConfiguration.documents)">{{ $t('globalHeader.documents') }}</span></li>
      <!--
        普通用户、开发者可进入开发者，管理员不可进入
        //角色信息：0：普通用户；1：开发者；2：管理员
        -->
      <li v-if="parseUserInfo.role"><span @click="navTo(jumpConfiguration.developer, parseUserInfo.role)">{{ $t('globalHeader.developer') }}</span></li>
      <!-- 管理者 -->
      <li v-if="parseUserInfo.isAdmin"><span @click="jumpAdmin">{{ $t('globalHeader.admin') }}</span></li>
      <!-- 工单 -->
      <li><span @click="jumpLink">{{ $t('globalHeader.work') }}</span></li>
    </ul>

    <!-- 费用信息 -->
    <finance-overview v-if="false" @jumpStore="jumpStore"></finance-overview>

    <!-- 消息组件 -->
    <header-notice class="action"/>

    <!-- 语言切换组件 -->
    <lang-select/>

    <!-- 账户信息 -->
    <a-dropdown overlayClassName="private-menu">
      <span class="action ant-dropdown-link user-dropdown-menu">
        <a-avatar class="avatar" size="small" :src="parseUserInfo.custImage" v-if="parseUserInfo.custImage"/>
        <img class="avatar default" src="./../../assets/images/default_user.png" v-else/>
        <!-- <span>{{ parseUserInfo.custAlias || parseUserInfo.username }}</span> -->
      </span>
      <a-menu slot="overlay">
        <!--<a-menu-item key="0">
          <router-link :to="{ name: 'center' }">
            <a-icon type="user"/>
            <span>个人中心</span>
          </router-link>
        </a-menu-item>
        <a-menu-item key="1">
          <router-link :to="{ name: 'settings' }">
            <a-icon type="setting"/>
            <span>账户设置</span>
          </router-link>
        </a-menu-item>-->
       <!-- <a-menu-item key="0">
          <router-link :to="{ name: 'My' }">
            <b-icon type="iconwodezhanghu"></b-icon>
            <span>{{ $t('globalHeader.userInfo.acountInfo') }}</span>
          </router-link>
        </a-menu-item>-->
        <a-menu-item key="1">
          <router-link :to="{ name: 'Robot and Designer' }">
            <b-icon type="iconxukeguanli"></b-icon>
            <span>{{ $t('globalHeader.userInfo.robot') }}</span>
          </router-link>
        </a-menu-item>
        <!-- <a-menu-item key="2">
          <router-link :to="{ name: 'order' }">
            <b-icon type="icondingdanguanli"></b-icon>
            <span>{{ $t('globalHeader.userInfo.order') }}</span>
          </router-link>
        </a-menu-item> -->
        <a-menu-item key="3">
          <router-link :to="{ name: 'Operation Log' }">
            <b-icon type="iconyewurizhi"></b-icon>
            <span>{{ $t('globalHeader.userInfo.operationLog') }}</span>
          </router-link>
        </a-menu-item>
        <!--<a-menu-item key="8">-->
        <!--  <router-link :to="{ name: 'Application Management Index' }">-->
        <!--    <b-icon type="iconwodekey"></b-icon>-->
        <!--    <span>{{ $t('globalHeader.userInfo.key') }}</span>-->
        <!--  </router-link>-->
        <!--</a-menu-item>-->
        <!--<a-menu-item key="7">-->
        <!--  <a href="javascript:;" @click="jumpStore('myapps')">-->
        <!--    <b-icon type="iconmoudle"></b-icon>-->
        <!--    <span>{{ $t('globalHeader.userInfo.downloadApp') }}</span>-->
        <!--  </a>-->
        <!--</a-menu-item>-->
        <a-menu-item key="9">
          <router-link :to="{ name: 'Card management' }">
            <b-icon type="iconkabao"></b-icon>
            <span>{{ $t('globalHeader.userInfo.cardP') }}</span>
          </router-link>
        </a-menu-item>
        <!-- <a-menu-item key="4">
          <a href="javascript:;" @click="jumpStore('myapps')">
            <b-icon type="iconmoudle"></b-icon>
            <span>{{ $t('globalHeader.userInfo.downloadApp') }}</span>
          </a>
        </a-menu-item>
        <a-menu-item key="5">
          <a href="javascript:;" @click="jumpStore('myInvoice')">
            <b-icon type="iconinvoice"></b-icon>
            <span>{{ $t('globalHeader.userInfo.invoice') }}</span>
          </a>
        </a-menu-item> -->
        <a-menu-divider/>
        <a-menu-item key="6">
          <a href="javascript:;" @click="handleLogout">
            <b-icon type="icontuichu"></b-icon>
            <span>{{ $t('globalHeader.userInfo.logOut') }}</span>
          </a>
        </a-menu-item>
      </a-menu>
    </a-dropdown>
  </div>
</template>

<script>
import HeaderNotice from './HeaderNotice'
import LangSelect from '@/components/tools/LangSelect'
import FinanceOverview from '@/components/tools/FinanceOverview'
import { mapGetters } from 'vuex'
import jumpConfig from './topNavJumpConf.js'
import { tipMsg, modalTip } from '@/utils/tipTools.js'
// import { session } from '@/utils/util'
// import Vue from 'vue'

export default {
  name: 'UserMenu',
  components: {
    HeaderNotice,
    LangSelect,
    FinanceOverview
  },
  computed: {
    ...mapGetters(['userInfo', 'token']),
    // 导航跳转路径配置信息
    jumpConfiguration () {
      return jumpConfig
    },
    parseUserInfo () {
      if (this.userInfo) {
        return JSON.parse(this.userInfo)
      } else {
        return {}
      }
    },
    // 开发者注册页面，分个人和企业
    developerRegUrl () {
      const devRegUrl = {
        'development': 'http://127.0.0.1:8111/store/selectDevType',
        'testing': 'https://192.168.0.14/store/selectDevType',
        'production': 'https://rpa.i-search.com.cn/store/selectDevType',
        'uat': 'https://rpa.i-search.com.cn/store/selectDevType'
      }
      return devRegUrl[process.env.VUE_APP_CURRENTMODE]
    },
    // 管理端
    adminUrl () {
      const url = {
        'development': 'http://localhost:8002/',
        'testing': 'https://192.168.0.14/admin',
        'production': 'https://rpa.i-search.com.cn/admin',
        'uat': 'https://rpa.i-search.com.cn/admin'
      }
      return url[process.env.VUE_APP_CURRENTMODE]
    }
  },
  methods: {
    // 跳管理者
    jumpAdmin () {
      window.open(this.adminUrl)
    },
    // 跳转
    navTo (goTo, role = '') {
      // 判断用户类型
      if (role) {
        if (String(role) === '0') {
          // 已经注册过，但是还在审核中
          if (this.parseUserInfo.devNo) {
            // 前往开发者申请页面
            window.open(this.developerRegUrl)
            // window.location.href = this.developerRegUrl
          } else {
            // 普通用户，可前往申请成为开发者
            modalTip(
              'confirm',
              `${this.$t('applyTips')}`,
              () => {
                // 前往开发者申请页面
                window.open(this.developerRegUrl)
                // window.location.href = this.developerRegUrl
              }
            )
          }
        } else if (String(role) === '1') {
          // 已经是开发者了，可前往开发者
          window.open(goTo)
          // location.href = goTo
        } else if (String(role) === '2') {
          // 管理员不可前往开发者
          tipMsg('warning', this.$t('devClientAccess'))
        }
      } else {
        if (goTo !== '#') {
          if (goTo.indexOf('support') !== -1) {
            window.open(goTo)
          } else {
            window.open(goTo)
            // location.href = goTo
          }
        } else {
          tipMsg('info', `${this.$t('developing')}`)
        }
      }
    },
    // 跳商城页面
    jumpStore (url) {
      window.open(`${this.$url.baseUrl}/store/${url}`)
    },
    // 跳工单页面
    jumpLink () {
      window.open(`${this.jumpConfiguration.workerOrder}account=${this.parseUserInfo.username}&token=${this.token}`)
    },
    // 跳社区页面
    jumpSNSLink () {
      window.open(`${this.jumpConfiguration.community}email=${this.parseUserInfo.username}&token=${this.token}`)
    },
    handleLogout () {
      const that = this
      this.$confirm({
        title: `${that.$t('logoutTip')}`,
        content: '',
        onOk () {
          return that.$store.dispatch('LogOut')
        },
        onCancel () {}
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @bgColor: #303030;
  @primaryFontColor: #F0F0F0;
  @fontBorderColor: #4977FC;
  .nav-menu {
    padding-left: 10px;
    display: inline;
    >li {
      position: relative;
      display: block;
      float: left;
      line-height: 62px;
      padding: 0 10px;
      font-size: 14px;
      color: @primaryFontColor;
      >span {
        cursor: pointer;
        &:hover {
          color: @fontBorderColor;
        }
      }
    }
  }

.private-menu{
  .ant-dropdown-menu{
    background: #303030;
    .ant-dropdown-menu-item{
      a {
        color: #fff !important;
      }
      i{
        margin-right: 8px;
      }
    }
    .ant-dropdown-menu-item-active {
      background: #464646;
      a {
        color: #4977FC !important;
      }
    }
  }
}
.default {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  margin-right: 10px;
}
  span.action {
    i {
      font-size: 20px;
      color: #fff;
      cursor: pointer;
      &:hover {
        color: @fontBorderColor;
      }
    }
  }
</style>
